import { Termin } from '@/domain/termine/shared/types/Termin';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { TerminPopoverContent } from './TerminPopoverContent';
import { usePopoverDirection } from '@/domain/termine/shared/utils/getPopoverDirection';

export function TerminPopover({
  termin,
  children,
}: {
  termin: Termin;
  children: React.ReactNode;
}) {
  const popoverDirection = usePopoverDirection();

  return (
    <Popover modal>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        side={popoverDirection}
        align="center"
        className="p-0 bg-transparent shadow-none border-none text-left"
        onInteractOutside={(e) => {
          e.stopPropagation();
        }}>
        <TerminPopoverContent termin={termin} />
      </PopoverContent>
    </Popover>
  );
}
